export const secondsToMillis = (amount: number): number => 1000 * amount;
export const minutesToMillis = (amount: number): number => 60 * secondsToMillis(amount);
export const hoursToMillis = (amount: number): number => 60 * minutesToMillis(amount);
